import Paper from '@material-ui/core/Paper';
import moment from 'moment';
import React from 'react';

import CardHeader from '../../../../components/CardHeader';
import { IEventItem } from '../../../../store/player/events/store';

interface IProps {
  item: IEventItem;
}

const EventStats = (props: IProps) => {
  const {
    item: { totalPlayers, flights, enrollments, firstTeeTime }
  } = props;

  const activePlayers = enrollments.filter(e => e.status === 'active').length;
  const spots = totalPlayers - activePlayers;
  const spotsAvailable = spots < 0 ? 0 : spots;

  return (
    <div className="event-stats">
      <Paper elevation={1} className={'paper'}>
        <div className="stats-content">
          <CardHeader label={`FIRST TEE TIME AT ${moment(firstTeeTime).format('h:mm A')}`} />
          <div className="stats">
            <div className="stat">
              <div className="value">{spotsAvailable}</div>
              <div className="label">SPOTS REMAINING</div>
            </div>
            <div className="stat">
              <div className="value">{activePlayers}</div>
              <div className="label">Total Players</div>
            </div>
            <div className="stat">
              <div className="value">{flights.length}</div>
              <div className="label">Flights</div>
            </div>
          </div>
        </div>
      </Paper>
    </div>
  );
};

export { EventStats };
